import { LocationDescriptor } from 'history';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { AppRoutes } from '../../../Configs/AppRoutes';
import { CRMQueryParameter } from '../../../Models/CRM/CRM';
import { AuthenticateResultType, AuthService } from '../../../Services/Authentication/AuthService';
import { LoadingView } from '../../Components/Widgets/LoadingView';
import { useQuery } from '../../Hooks/URL/URLUtils';

export const CRMLandingPage = () => {
    const { loginInProgress } = useCRMLandingPageController();
    return <LoadingView darkColor loading={loginInProgress} style={{ background: '#FFFFFF' }} />;
};

export const useCRMLandingPageController = () => {
    const browserHistory = useHistory();
    const params: CRMQueryParameter = useQuery<CRMQueryParameter>();

    const [loginInProgress, setLoginInProgress] = useState(false);

    React.useEffect(() => {
        crmLogin();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const crmLogin = async () => {
        try {
            setLoginInProgress(true);
            const response: AuthenticateResultType = await AuthService.CRMlogin(params);
            setLoginInProgress(false);

            const nextLocation = buildConfigUrl(params.id_config);
            if (response === AuthenticateResultType.SUCCESS) {
                browserHistory.push(nextLocation);
            }
        } catch (error) {
            setLoginInProgress(false);
            console.error('crm.login.error', error);
        }
    };

    return { loginInProgress };
};

const buildConfigUrl = (configId: string) => {
    const searchParams = new URLSearchParams();
    if (configId) {
        searchParams.set('configId', configId);
    }
    const location: LocationDescriptor<unknown> = {
        pathname: AppRoutes.DEFAULT_ROUTE,
        search: `?${searchParams.toString()}`,
    };
    return location;
};
